// @flow
import { httpClient } from 'angieslist-app-platform';

const getCoupons = (serviceProviderId: string): any => httpClient.get(`/gateway/office-home/v1/service_providers/${serviceProviderId}/coupons`, {
  headers: {
    'X-ANGI-CallerType': 'ServiceProvider',
    'X-ANGI-CallerId': serviceProviderId,
  },
});

const getDeals = (
  serviceProviderId: string,
  offset: number = 0,
  limit: number = 10,
): any => httpClient.get(`/gateway/service-provider-profile/v3/service_provider/${serviceProviderId}/offer`, {
  params: {
    offset,
    limit,
  },
  headers: {
    'X-ANGI-CallerType': 'ServiceProvider',
    'X-ANGI-CallerId': serviceProviderId,
  },
});

export default {
  getCoupons,
  getDeals,
};



// WEBPACK FOOTER //
// ./src/modules/store/common/dealsService.js